import { Portal } from './interfaces'

export const CONFIG_ENVIRONMENT = 'REPLACE:CONFIG_ENVIRONMENT';

export const CONFIG_VERSION = 'REPLACE:CONFIG_APP_VERSION';

// Default UPP Client config.
export const LOCAL_STORAGE_IDENTIFIER_DEBUG = 'UPP_DEBUG';

export const PARENT_TIMEOUT_DEFAULT = 30000
export const CHILD_TIMEOUT_DEFAULT = 8000
export const CHILD_TIMEOUT_MOBILE = 6000
export const CHILD_TIMEOUT_ANDROID = 30000

export const SUPPORTED_BRANDS: Portal[] = [
  'gmx',
  'gmxat',
  'gmxch',
  'gmxcom',
  'gmxcouk',
  'gmxes',
  'gmxfr',
  'mailcom',
  'webde'
]

export const CONFIG_SENTRY_DSN = 'REPLACE:CONFIG_SENTRY_DSN'
